import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircle, Clock, SearchX, ShieldAlert, Laptop } from 'lucide-react';
export const Problem = () => {
  const problems = [{
    icon: <Clock className="w-6 h-6 text-red-400" data-id="element-239" />,
    title: 'Perdés horas buscando información.',
    desc: 'Cada nuevo caso implica investigar desde cero, buscar jurisprudencia, adaptar modelos y organizar documentación.'
  }, {
    icon: <SearchX className="w-6 h-6 text-red-400" data-id="element-240" />,
    title: 'Trabajás con material disperso.',
    desc: 'Tus modelos están en carpetas distintas, los fallos en otro lado y las estrategias dependen de lo que recuerdes.'
  }, {
    icon: <ShieldAlert className="w-6 h-6 text-red-400" data-id="element-241" />,
    title: 'Inseguridad al actuar.',
    desc: 'La duda sobre si estás utilizando el mejor argumento, la mejor estrategia o la jurisprudencia más adecuada.'
  }, {
    icon: <Laptop className="w-6 h-6 text-red-400" data-id="element-242" />,
    title: 'Te cuesta incorporar nuevas herramientas.',
    desc: 'IA jurídica, prueba digital, protección de datos, litigación oral y marketing jurídico ya forman parte de la profesión moderna.'
  }, {
    icon: <AlertCircle className="w-6 h-6 text-red-400" data-id="element-243" />,
    title: 'Improvisación constante.',
    desc: 'Cada consulta parece empezar desde cero cuando deberías contar con un sistema profesional organizado.'
  }];
  return <section className="py-20 bg-legal-900" data-id="element-244">
      <div className="container mx-auto px-4" data-id="element-245">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-246">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-6" data-id="element-247">
            Ejercer sin un sistema profesional completo te hace perder{' '}
            <span className="text-red-400" data-id="element-248">
              tiempo, dinero y oportunidades.
            </span>
          </h2>
          <p className="text-lg text-slate-400" data-id="element-249">
            El derecho está cambiando más rápido que nunca. Hoy no alcanza con
            conocer la ley. Los abogados necesitan herramientas, tecnología,
            estrategias y sistemas de trabajo que les permitan resolver más
            casos en menos tiempo.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 max-w-4xl mx-auto" data-id="element-250">
          {problems.map((prob, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: idx * 0.1
        }} className={`bg-legal-800/50 border border-red-900/30 p-6 rounded-xl flex gap-4 ${idx === 4 ? 'md:col-span-2 md:max-w-md md:mx-auto' : ''}`} data-id="element-251">
              <div className="shrink-0 mt-1" data-id="element-252">{prob.icon}</div>
              <div data-id="element-253">
                <h3 className="text-lg font-bold text-white mb-2" data-id="element-254">
                  {prob.title}
                </h3>
                <p className="text-slate-400 text-sm leading-relaxed" data-id="element-255">
                  {prob.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
};